import { render } from "./EditProviders.vue?vue&type=template&id=da0a266e&scoped=true"
import script from "./EditProviders.vue?vue&type=script&lang=js"
export * from "./EditProviders.vue?vue&type=script&lang=js"

import "./EditProviders.vue?vue&type=style&index=0&id=da0a266e&scoped=true&lang=css"
import "./../../../assets/styles/admin/form.scss?vue&type=style&index=1&id=da0a266e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da0a266e"]])

export default __exports__